export default __webpack_public_path__ + "438f74bbb58cd031fd13222b17c697da.png";